export default __webpack_public_path__ + "static/Stickers-broker-2024-e7a52a150c03b701b9bc8554e087fbce.png";